import wrapperedLS from 'store'

const CURRENCY = 'currency'

const data = {}
let hasLocalStorage = false

if (localStorage) {
  try {
    const x = 'storageTest'
    localStorage.setItem(x, x)
    localStorage.removeItem(x)
    hasLocalStorage = true
  } catch (e) {
    hasLocalStorage = false
  }
}

class StorageUtilities {
  setItem (key, value) {
    if (hasLocalStorage) {
      localStorage.setItem(key, value)
    } else {
      data[key] = value
    }
  }

  getItem (key) {
    if (hasLocalStorage) {
      return localStorage.getItem(key)
    }
    return data[key]
  }

  removeItem (key) {
    if (hasLocalStorage) {
      localStorage.removeItem(key)
    } else {
      data[key] = null
    }
  }
}

const storageUtilities = new StorageUtilities()

export function getEvokePolicy () {
  const res = storageUtilities.getItem('EVOKE_POLICY') || '{}'
  return JSON.parse(res)
}

export function setEvokePolicy (val = {}) {
  return storageUtilities.setItem('EVOKE_POLICY', JSON.stringify(val))
}

export function getCurrencyInfo () {
  const ret = wrapperedLS.get(CURRENCY) || '[]'
  return JSON.parse(ret)
}

export function setCurrencyInfo (info = []) {
  wrapperedLS.set(CURRENCY, JSON.stringify(info))
}

export function getLocale () {
  return wrapperedLS.get('locale')
}

export function setLocale (val) {
  return wrapperedLS.set('locale', val)
}
